import { useCallback, useEffect } from 'react';
import { useBlocker } from 'react-router-dom';
import { BLOCKED } from '@app/configs/blocker';
export const useNavigationBlocker = ({ isBlocked, onBlock }) => {
    const shouldBlock = useCallback(({ currentLocation, nextLocation }) => {
        if (!isBlocked) {
            return false;
        }
        if (currentLocation.pathname === nextLocation.pathname) {
            return false;
        }
        return true;
    }, [isBlocked]);
    const blocker = useBlocker(shouldBlock);
    useEffect(() => {
        if (blocker.state === BLOCKED) {
            onBlock();
        }
    }, [blocker.state, onBlock]);
    useEffect(() => {
        const handleBeforeUnload = (event) => {
            if (isBlocked) {
                event.preventDefault();
                event.returnValue = '';
            }
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [isBlocked]);
    return {
        blocker,
        isBlocked: blocker.state === BLOCKED,
        reset: () => {
            if (blocker.state === BLOCKED) {
                blocker.reset();
            }
        },
        proceed: () => {
            if (blocker.state === BLOCKED) {
                blocker.proceed();
            }
        },
    };
};
